/* Chesto · Category Bento — entry stagger.
   Pure progressive enhancement: tiles default to fully visible,
   then this script hides them via [data-cb-enter] and triggers
   the staggered .is-in reveal when the section enters the viewport. */
(function () {
  if (typeof window === 'undefined') return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('.cb-section');
    sections.forEach(function (section) {
      var head = section.querySelector('.cb-head');
      var tiles = section.querySelectorAll('.cb-tile');
      if (head) head.setAttribute('data-cb-enter', '');
      tiles.forEach(function (t, i) {
        t.setAttribute('data-cb-enter', '');
        t.style.setProperty('--cb-delay', (i * 160) + 'ms');
      });

      var play = function () {
        if (head) head.classList.add('is-in');
        tiles.forEach(function (tile) { tile.classList.add('is-in'); });
      };

      var reset = function () {
        if (head) head.classList.remove('is-in');
        tiles.forEach(function (tile) { tile.classList.remove('is-in'); });
      };

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              requestAnimationFrame(play);
            } else {
              // Reset when section leaves viewport so it can replay on re-entry
              reset();
            }
          });
        }, { rootMargin: '0px 0px -80px 0px', threshold: 0 });
        io.observe(section);
      } else {
        play();
      }
    });
  });
})();
